import type { RootStore } from '~/stores/root.store';

export class YearInReviewService {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async getYearInReviewData(userId: string) {
        const { apiService } = this.rootStore;
        const response = await apiService.apiRequest<any>({
            method: 'get',
            url: `/api/v2/users/${userId}/year_in_review_2024`
        });
        return response;
    }

    async sendReferralUrlToUser(userId: string, email, referral_url) {
        const { apiService } = this.rootStore;

        const response = await apiService.apiRequest<any>({
            method: 'post',
            url: `/api/v2/users/${userId}/year_in_review_2024/send_mail`,
            data: {
                email,
                referral_url
            }
        });
        return response;
    }
}
